const regions = [
  {
    name: 'İzmir',
    desc: 'Merkez ilçeler başta olmak üzere Bornova, Buca, Karşıyaka, Konak, Bayraklı, Karabağlar, Çiğli, Gaziemir, Balçova ve tüm İzmir ilçelerinde üretim, montaj ve servis hizmeti sunuyoruz. Yerinde keşif ücretsizdir.',
    icon: 'ri-map-pin-2-fill',
    highlight: true,
  },
  {
    name: 'Manisa',
    desc: 'Manisa merkez, Akhisar, Salihli, Turgutlu, Soma ve tüm Manisa ilçelerine lightbox üretimi ve teslimat yapıyoruz. Büyük projelerde montaj ekibimiz bölgeye gelir.',
    icon: 'ri-map-pin-line',
    highlight: false,
  },
  {
    name: 'Aydın',
    desc: 'Aydın merkez, Kuşadası, Didim, Nazilli, Söke ilçelerinde lightbox tabela siparişi alıyoruz. Kargo ile güvenli teslimat ya da nakliye ile uygulama imkânı.',
    icon: 'ri-map-pin-line',
    highlight: false,
  },
  {
    name: 'Muğla',
    desc: 'Bodrum, Marmaris, Fethiye, Milas, Ortaca ve tüm Muğla ilçelerine ışıklı tabela ve dış mekan lightbox üretimi yapıyoruz.',
    icon: 'ri-map-pin-line',
    highlight: false,
  },
  {
    name: 'Türkiye Geneli',
    desc: 'Kargo ve nakliye ile Türkiye\'nin her iline teslimat yapıyoruz. Büyük ölçekli kurumsal projelerde Türkiye genelinde kurulum ve teknik destek hizmeti sunuyoruz.',
    icon: 'ri-earth-line',
    highlight: false,
  },
];

export default function LocalSEO() {
  return (
    <section className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-red-400 text-sm font-semibold uppercase tracking-widest mb-4">
            <span className="w-8 h-0.5 bg-red-500 inline-block"></span>
            Hizmet Bölgeleri
            <span className="w-8 h-0.5 bg-red-500 inline-block"></span>
          </div>
          <h2 className="text-4xl font-black text-white mb-4">
            İzmir ve Çevre İllerde <br />
            <span className="text-red-500">Lightbox Hizmeti</span>
          </h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto leading-relaxed">
            Ege bölgesinin lider lightbox üreticisi olarak İzmir merkezli üretim tesisimizden tüm Türkiye'ye hizmet sunuyoruz.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {regions.map((r) => (
            <div
              key={r.name}
              className={`rounded-2xl p-6 ${
                r.highlight
                  ? 'bg-red-600 text-white'
                  : 'bg-white/5 border border-white/10 text-white'
              }`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl mb-4 ${
                r.highlight ? 'bg-white/20' : 'bg-red-500/20'
              }`}>
                <i className={`${r.icon} text-xl ${r.highlight ? 'text-white' : 'text-red-400'}`}></i>
              </div>
              <h3 className={`font-bold text-base mb-2 ${r.highlight ? 'text-white' : 'text-white'}`}>
                {r.name}
              </h3>
              <p className={`text-sm leading-relaxed ${r.highlight ? 'text-white' : 'text-gray-400'}`}>
                {r.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
